import { useSearchParams } from "react-router-dom";
import { useDispatchApp } from "../../../../lib/redux";
import { useInView } from "react-intersection-observer";
import { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import Loader from "../../../../components/Loaders/Loader";
import { startGetCampaignLogs } from "../../../../actions/adsCampaigns";
import LogEntry from "../../../NewAdsCampaign/components/CampaignLogs/components/LogEntry";
import {
  ADS_CAMPAIGNS_LOGS_TITLE,
  EMPTY_CHANGES,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../utils/constants";

const LogsSection = ({ filteredLogs, isLoadingLogs }) => {
  const [cachedNameEntities, setCachedNameEntities] = useState({});
  const [lastKey, setLastKey] = useState(null);
  const [params] = useSearchParams();
  const campaignID = params.get("campaignID");

  const dispatch = useDispatchApp();

  const { t } = useTranslationApp();

  const { ref, inView } = useInView({
    triggerOnce: false,
    rootMargin: "20px 0px",
  });

  const onGetNextLogs = async () => {
    if (isLoadingLogs) return;
    await dispatch(
      startGetCampaignLogs({
        campaignID,
        lastKey,
        onChangeLastKey: setLastKey,
      })
    );
  };

  useEffect(() => {
    if (inView) {
      onGetNextLogs();
    }
    // eslint-disable-next-line
  }, [inView]);

  if (isLoadingLogs) return <Loader fullWidth />;

  const filteredLogsArray = filteredLogs;

  if (!filteredLogsArray.length) {
    return null;
  }

  return (
    <Box
      id="logs-section"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        gap: 3,
        height: "100%",
        pt: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
        }}
      >
        {t(ADS_CAMPAIGNS_LOGS_TITLE)}
      </Typography>

      <Box
        sx={{
          backgroundColor: "fields.background",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          boxShadow: BOX_SHADOW_THEME,
          borderRadius: BORDER_RADIUS,
          p: 2,
          minHeight: 120,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            backgroundColor: "transparent",
            backgroundImage: "none",
            px: {
              xs: 1,
              sm: 2,
            },
          }}
        >
          <Box sx={{ mt: 2 }}>
            {filteredLogsArray.length === 0 ? (
              <Typography align="center" sx={{ py: 4 }}>
                {t(EMPTY_CHANGES)}
              </Typography>
            ) : (
              filteredLogsArray.map((log, index) => (
                <LogEntry
                  isExpanded={true}
                  key={log.creationTime}
                  log={log}
                  isLast={index === filteredLogsArray.length - 1}
                  cachedNameEntities={cachedNameEntities}
                  onChangeCachedNameEntities={(newEntities) =>
                    setCachedNameEntities((prev) => ({
                      ...prev,
                      ...newEntities,
                    }))
                  }
                />
              ))
            )}
            <Box
              ref={ref}
              sx={{
                height: 20,
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            />
          </Box>
        </Paper>
      </Box>
    </Box>






  );
};

export default LogsSection;
